import Closable from './closable';
import Selectable from './selectable';
import './styles/index.scss';
import Tag from './tag';
const ExpandedTag = Tag;
ExpandedTag.Selectable = Selectable;
ExpandedTag.Closable = Closable;
export default ExpandedTag;
